export const initialState = {
  authorizations: [],
  page: {},
  links: {},
  loadingAuthorizations: false,
  error: {},
  errorAlert: false,
  newAuthorization: {
    type: {},
    error: {},
    sponsorForm: {},
    beneficiarySearch: {
      sponsorSlug: null,
      formSlug: null,
      inputs: []
    },
    steps: {
      type: false,
      sponsor: false,
      method: false,
      beneficiary: false,
      beneficiarySearchComplete: false
    },
    navBarType: '',
  },
  beneficiaries: [],
  beneficiarySelected: {},
  beneficiary: {},
  loadingVerification: false,
  loadingCreateClaim: false,
  createClaimError: {},
  biometricVerificationResult: {},
  authorizationResult: null,
  outpatientCareForm: {
    beneficiaryFields: {},
    doctorFields: {},
    isVerified: null
  }
}
  
export default {
  ...initialState
}
